<template>
  <FourElement></FourElement>
  <div class="collection-container">
    <Filter></Filter>
    <List></List>
    <AddModal></AddModal>
  </div>
</template>

<script>
import FourElement from './components/FourElement.vue'
import List from './components/List.vue'
import AddModal from './components/AddModal.vue'
import Filter from './components/Filter.vue'
import { toRefs, reactive, provide, onMounted } from 'vue'
// import dayjs from 'dayjs'
import {
  queryPageTaskUi,
  addTaskUi,
  updateTaskUi,
  deleteTaskUi,
  getAllTaskCategory,
  getAllTaskInfo
} from 'server/modules/task'
import useAPI from 'UseApi'
import { common_lang_get } from 'server/modules/3426'
const { common_querySiteInfo_get_ } = useAPI(null, [3426])
import { message } from 'ant-design-vue'
// import { message } from 'ant-design-vue'
export default {
  components: {
    FourElement,
    List,
    Filter,
    AddModal
  },
  setup() {
    const state = reactive({
      searchParams: {
        // terminalId: 1,
        brandId: 1,
        channelId: 1,
        siteId: 1
      },
      pagination: {
        current: 1, //默认的当前页数
        pageSize: 10, //每页显示几条数据
        total: 0,
        onChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.getTabList()
        }
      },
      //表格数据
      dataSource: [
        // {
        //   taskUiId: 1,
        //   assortName: 11,
        //   typeName: 22,
        //   assortId: 1,
        //   typeId: 2,
        //   day: 12,
        //   number: 13,
        //   achieveRewards: 3,
        //   uiDesc: JSON.stringify([{ key: 11, value: 22 }]),
        //   taskUiName: JSON.stringify([{ key: 11, value: 22 }])
        // }
      ],
      brands: [],
      channels: [],
      sites: [],
      //语言数据
      langList: [],
      //0新增 1编辑 2详情
      modalType: 0,
      //列
      columns: [
        {
          title: '序号',
          align: 'center',
          dataIndex: 'taskUiId',
          key: 'taskUiId'
        },
        {
          title: '任务类型',
          dataIndex: 'taskType',
          key: 'taskType',
          align: 'center'
        },
        {
          title: '任务ID',
          align: 'center',
          dataIndex: 'taskId',
          key: 'taskId'
        },
        {
          title: '展示类型',
          dataIndex: 'showType',
          key: 'showType',
          align: 'center'
        },
        // {
        //   title: '创建人',
        //   dataIndex: 'createUser',
        //   key: 'createUser',
        //   align: 'center'
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operate',
          align: 'center'
        }
      ],
      //任务数据
      taskSelect: [
        // {
        //   id: 1,
        //   chatGroupName: 22
        // },
        // {
        //   id: 2,
        //   chatGroupName: 33
        // }
      ],
      //分类数据
      assortSelect: [
        // {
        //   taskCategoryId: 1,
        //   taskCategoryName: 22
        // },
        // {
        //   taskCategoryId: 2,
        //   taskCategoryName: 33
        // }
      ],
      uiTerminalOps: {
        1: 'web',
        2: 'app',
        0: 'all'
      },
      //筛选
      filterData: {
        taskId: '',
        taskType: undefined,
        showType: undefined
      },
      //重置筛选
      resetFilter: () => {
        state.filterData = {
          taskId: '',
          taskType: undefined,
          showType: undefined
        }
        state.initList()
      },
      initList: () => {
        state.getTaskList()
        state.getTabList()
        state.initCommonLang()
        state.getAssortList()
      },
      //table数据
      getTabList: () => {
        const param = {
          ...state.searchParams,
          pageNum: state.pagination.current,
          pageSize: state.pagination.pageSize,
          taskId: state.filterData.taskId,
          taskType: state.filterData.taskType,
          showType: state.filterData.showType
        }
        // alert(JSON.stringify(param))
        queryPageTaskUi(param)
          .then(e => {
            if (e.success) {
              state.dataSource = e.data.data.list.records
              state.pagination.total = e.data.data.total
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      getTaskList() {
        if (!state.form.uiTerminal) {
          state.form.uiTerminal = 0
        }
        if (!state.form.taskCategory) {
          state.form.taskCategory = undefined
        }
        const param = {
          ...state.searchParams,
          taskTerminal: state.form.uiTerminal,
          taskCategory: state.form.taskCategory,
          taskId: state.form.taskId
        }
        getAllTaskInfo(param)
          .then(e => {
            if (e.success) {
              state.taskSelect = e.data.data
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      getAssortList() {
        getAllTaskCategory()
          .then(e => {
            if (e.success) {
              state.assortSelect = e.data.data
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      initCommonLang: async () => {
        const { data } = await common_lang_get(state.searchParams)
        state.langList = Object.entries(data.languageMap).map(
          ([key, value]) => ({
            label: key,
            value
          })
        )
      },
      modalVisible: false,
      formRef: null,
      form: {
        uiDesc: [
          {
            key: undefined,
            value: undefined
          }
        ],
        taskUiName: [
          {
            key: undefined,
            value: undefined
          }
        ]
      },
      editType: '',
      //校验
      rules: {
        taskId: [{ required: true, message: '请选择任务！' }],
        taskCategory: [{ required: true, message: '请选择任务分类！' }]
      },
      add: type => {
        state.editType = 1
        state.modalType = type
        state.modalVisible = true
        state.form.taskType = 1
        state.form.uiTerminal = 1
        // state.form.displayLocation = 1
        state.form.showType = 1
        state.taskSelect = []
        state.getTaskList()
      },
      // changeRangePicker() {
      //   state.form.expStartDate =
      //     state.form.emptyTime !== null
      //       ? dayjs(state.form.emptyTime[0]).format('YYYY-MM-DD HH:mm:ss')
      //       : ''
      //   state.form.expEndDate =
      //     state.form.emptyTime !== null
      //       ? dayjs(state.form.emptyTime[1]).format('YYYY-MM-DD HH:mm:ss')
      //       : ''
      //   console.log(state.form.expStartDate)
      //   console.log(state.form.expEndDate)
      // },
      // selectType() {
      //   if (state.form.showType === 1) {
      //     state.form.startCopywriting = ''
      //     state.form.endCopywriting = ''
      //     state.form.bgUrl = ''
      //     state.form.startSynchronous = 0
      //     state.form.bgUrlTwo = ''
      //     state.form.endSynchronous = 0
      //   } else {
      //     state.form.startCopywriting = ''
      //     state.form.endCopywriting = ''
      //     state.form.uiStartUrl = ''
      //     state.form.displayLocation = 1
      //     state.form.uiEndUrl = ''
      //   }
      // },
      bodyStyle: {
        height: '750px',
        overflow: 'hidden',
        overflowY: 'scroll'
      },
      //添加直播头像
      imageType1: {
        tip: 'PC端尺寸: 60*60',
        size: 2048,
        width: 60,
        height: 60
      },
      imageType2: {
        tip: 'APP端尺寸: 46*46',
        size: 2048,
        width: 46,
        height: 46
      },
      addNameContent() {
        state.form.taskUiName.push({
          key: undefined,
          value: undefined
        })
        console.log(state.form.taskUiName)
      },
      removeNameContent: info => {
        if (state.form.taskUiName.length > 1) {
          const index = state.form.taskUiName.indexOf(info)
          if (index !== -1) {
            state.form.taskUiName.splice(index, 1)
          }
        }
      },
      //获取直播头像图片地址
      setFaceUrl: url => {
        state.form.uiStartWebUrl = url
        state.formRef.clearValidate(['uiStartWebUrl'])
      },
      setFaceUrlTwo: url => {
        state.form.uiStartAppUrl = url
        state.formRef.clearValidate(['uiStartAppUrl'])
      },
      setFaceUrlThree: url => {
        state.form.uiEndWebUrl = url
        state.formRef.clearValidate(['uiEndWebUrl'])
      },
      setFaceUrlFour: url => {
        state.form.uiEndAppUrl = url
        state.formRef.clearValidate(['uiEndAppUrl'])
      },
      //删除直播头像图片
      delFaceImg: () => {
        state.form.uiStartWebUrl = ''
      },
      delFaceImgTwo: () => {
        state.form.uiStartAppUrl = ''
      },
      delFaceImgThree: () => {
        state.form.uiEndWebUrl = ''
      },
      delFaceImgFour: () => {
        state.form.uiEndAppUrl = ''
      },
      selectType() {
        if (state.form.uiTerminal === 1) {
          state.form.uiStartWebUrl = ''
          state.form.uiStartAppUrl = ''
          state.form.uiEndWebUrl = ''
          state.form.uiEndAppUrl = ''
        } else if (state.form.uiTerminal === 2) {
          state.form.uiStartWebUrl = ''
          state.form.uiStartAppUrl = ''
          state.form.uiEndWebUrl = ''
          state.form.uiEndAppUrl = ''
        } else if (state.form.uiTerminal === 0) {
          state.form.uiStartWebUrl = ''
          state.form.uiStartAppUrl = ''
          state.form.uiEndWebUrl = ''
          state.form.uiEndAppUrl = ''
        }
        state.taskSelect = []
        state.form.taskId = undefined
        state.getTaskList()
      },
      selectTypeTwo() {
        state.taskSelect = []
        state.form.taskId = undefined
        state.getTaskList()
      },
      changeTaskUiName() {
        let keys = []
        if (state.form.taskUiName.length > 0) {
          for (let i = 0; i < state.form.taskUiName.length; i++) {
            keys.push(state.form.taskUiName[i].key)
          }
          let keysNum = keys.length
          //去重
          let newList = Array.from(new Set(keys))
          let newKeysNum = newList.length
          if (keysNum !== newKeysNum) {
            message.warning('语言重复，请勿选择相同语言！')
          }
        }
      },
      changeUiDesc() {
        let keys = []
        if (state.form.uiDesc.length > 0) {
          for (let i = 0; i < state.form.uiDesc.length; i++) {
            keys.push(state.form.uiDesc[i].key)
          }
          let keysNum = keys.length
          //去重
          let newList = Array.from(new Set(keys))
          let newKeysNum = newList.length
          if (keysNum !== newKeysNum) {
            message.warning('语言重复，请勿选择相同语言！')
          }
        }
      },
      // //添加直播封面
      // imageType2: {
      //   tip: '尺寸 XX*XX',
      //   size: 2048
      // },
      // //获取直播封面图片地址
      // setBgUrl: url => {
      //   state.form.bgUrl = url
      //   state.formRef.clearValidate(['bgUrl'])
      // },
      // setBgUrlTwo: url => {
      //   state.form.bgUrlTwo = url
      //   state.formRef.clearValidate(['bgUrlTwo'])
      // },
      // //删除直播封面图片
      // delBgImg: () => {
      //   state.form.bgUrl = ''
      // },
      // delBgImgTwo: () => {
      //   state.form.bgUrlTwo = ''
      // },
      addContent() {
        state.form.uiDesc.push({
          key: undefined,
          value: undefined
        })
        console.log(state.form.uiDesc)
      },
      removeContent: info => {
        if (state.form.uiDesc.length > 1) {
          const index = state.form.uiDesc.indexOf(info)
          if (index !== -1) {
            state.form.uiDesc.splice(index, 1)
          }
        }
      },
      modalCancel: () => {
        state.formRef.clearValidate()
        state.form = {
          uiDesc: [
            {
              key: undefined,
              value: undefined
            }
          ],
          taskUiName: [
            {
              key: undefined,
              value: undefined
            }
          ]
        }
        state.modalVisible = false
      },
      modalSubmit: async () => {
        state.formRef
          .validateFields()
          .then(() => {
            // if (state.form.showType === 1) {
            //   state.form.startSynchronous = ''
            //   state.form.endSynchronous = ''
            // } else {
            //   state.form.displayLocation = ''
            // }
            const param = {
              ...state.form
            }

            param.uiBrand = state.searchParams.brandId
            param.uiChannel = state.searchParams.channelId
            param.uiSite = state.searchParams.siteId
            // state.form.terminalId = state.searchParams.terminalId

            // param.taskId = JSON.stringify(param.taskId)
            param.uiDesc = JSON.stringify(param.uiDesc)
            param.taskUiName = JSON.stringify(param.taskUiName)
            // alert(JSON.stringify(state.form))
            // return false
            if (param.taskUiId) {
              updateTaskUi(param)
                .then(e => {
                  if (e.success) {
                    message.success('更新成功')
                    state.formRef.clearValidate()
                    state.form = {
                      uiDesc: [
                        {
                          key: undefined,
                          value: undefined
                        }
                      ],
                      taskUiName: [
                        {
                          key: undefined,
                          value: undefined
                        }
                      ]
                    }
                    state.modalVisible = false
                    state.initList()
                  } else {
                    message.warning(e.data)
                  }
                })
                .catch(err => {
                  console.log('err: ', err)
                  message.warning(err.retInfo)
                })
            } else {
              addTaskUi(param)
                .then(e => {
                  if (e.success) {
                    if (e.data.succes) {
                      message.success('添加成功')
                      state.formRef.clearValidate()
                      state.form = {
                        uiDesc: [
                          {
                            key: undefined,
                            value: undefined
                          }
                        ],
                        taskUiName: [
                          {
                            key: undefined,
                            value: undefined
                          }
                        ]
                      }
                      state.modalVisible = false
                      state.initList()
                    } else {
                      message.warning(e.data.data)
                    }
                  } else {
                    message.warning(e.retInfo)
                  }
                })
                .catch(err => {
                  console.log('err: ', err)
                  message.warning(err.retInfo)
                })
            }
          })
          .catch(e => {
            console.log('e: ', e)
          })
      },
      handleEdit: (type, info) => {
        if (info) {
          state.form = {
            ...info,
            // taskId: JSON.parse(info.taskId),
            uiDesc: JSON.parse(info.uiDesc),
            taskUiName: JSON.parse(info.taskUiName)
          }
          state.editType = 2
          state.modalType = type
          state.modalVisible = true
          state.taskSelect = []
          state.getTaskList()
        }
      },
      handleDel: info => {
        if (info) {
          deleteTaskUi(info)
            .then(e => {
              if (e.success) {
                message.success('删除成功')
                state.initList()
              } else {
                message.warning(e.data)
              }
            })
            .catch(err => {
              console.log('err: ', err)
              message.warning(err.retInfo)
            })
        }
      }
      // handleOpen: info => {
      //   if (info) {
      //     const data = {
      //       id: info.id,
      //       pdp: info.pdp,
      //       collection: info.collection,
      //       specialPage: info.specialPage,
      //       home: info.home
      //     }
      //     updateTaskUi(data)
      //       .then(e => {
      //         if (e.success) {
      //           message.success('设置成功')
      //           state.initList()
      //         } else {
      //           message.warning(e.data)
      //         }
      //       })
      //       .catch(err => {
      //         console.log('err: ', err)
      //         message.warning(err.retInfo)
      //       })
      //   }
      // }
    })
    onMounted(() => {
      common_querySiteInfo_get_({
        state
      })
      state.initList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
